import React from 'react';
import { Layout } from 'antd';
import { LayoutProps as LayoutCopyProps } from 'antd/lib/layout';

export type LayoutProps = LayoutCopyProps;

const ProLayout: React.FC<LayoutProps> = React.forwardRef<any, LayoutProps>(
  (props, ref) => {
    const { children, ...resProps } = props;

    return (
      <Layout ref={ref} {...resProps}>
        {children}
      </Layout>
    );
  },
);

export default ProLayout;
